import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { ArrowLeftIcon, CloseIcon } from '@root/styles/icons';
import { StyledSlider } from '../../SlideDatePicker';

import { HEADER_HEIGHT, STICKY_BAR_HEIGHT } from './constants';

export const SplitBarWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  ${media.md`
    flex-direction: row;
  `}
`;

export const FormWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${HEADER_HEIGHT}px - ${STICKY_BAR_HEIGHT}px);

  ${media.md`
    padding: 0 20px;
  `}
`;

export const LeftSideBarWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: ${STICKY_BAR_HEIGHT}px;

  ${media.md`
    padding-right: 10px;
    width: 66.666%;
    height: calc(100vh - ${HEADER_HEIGHT}px - ${STICKY_BAR_HEIGHT}px);
  `}
`;

export const RightSideBarWrapper = styled.div`
  align-items: flex-start;

  ${media.md`
    display: flex;
    width: 33.333%;
    padding-left: 10px;
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
  justify-content: space-between;
  padding: 12px 20px;
`;

export const Heading = styled.h2`
  font-size: 32px;
  font-family: ${({ theme }) => theme.headerFont};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  margin-bottom: 0;

  ${media.sm`

    margin-bottom: 30px;
    font-size: 35px;
  `}
`;

export const Subheading = styled.h3`
  font-size: 16px;
  font-family: ${({ theme }) => theme.headerFont};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  margin: 0;
`;

export const MobileHeading = styled.h2`
  font-size: 20px;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 45px 0 0;
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.headerFont};
  margin: 0;

  ${media.md`
    display: none;
  `}
`;

export const CloseModalButton = styled(CloseIcon)`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  cursor: pointer;

  ${media.md`
    right: 5px;
  `}
`;

export const PrevStepButton = styled(ArrowLeftIcon)`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  width: 35px;
  height: 35px;
  margin-right: 10px;
  flex-shrink: 0;
  cursor: pointer;
`;

export const FormStep = styled.div<{ noGutter?: boolean; isNarrow?: boolean }>`
  padding-bottom: ${({ noGutter }) => (noGutter ? `${STICKY_BAR_HEIGHT * 2}px` : '250px')};
  max-width: ${({ isNarrow }) => (isNarrow ? '920px' : 'none')};

  ${StyledSlider} {
    margin-left: 0;
    padding: 0;
  }
`;
